"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylePreview = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/components/site-menu/component");
const component_2 = require("@front/layouts/default-layout/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="style-preview-page">
    <div class="row">
      <div class="col-12">
        <div class="mb-3">
          <h1>${'style.preview.title'.t()}</h1>
          <div class="text-zero top-right-button-container">
            ${(0, fast_element_1.when)(x => x.canEdit, (0, fast_element_1.html) `
              <button @click="${(x, c) => x.editStyle()}" type="button"
                class="top-right-button mr-2 btn btn-primary btn-lg">${'style.preview.edit'.t()}</button>
            `)}
            <button @click="${(x, c) => x.goBack()}" type="button"
              class="top-right-button mr-1 btn btn-secondary btn-lg">${'style.preview.back'.t()}</button>
          </div>
        </div>

        ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
          <div class="text-center p-5">
            <div class="spinner-border" role="status">
              <span class="sr-only">${'general.loading'.t()}</span>
            </div>
          </div>
        `)}

        ${(0, fast_element_1.when)(x => !x.loading && x.styleData, (0, fast_element_1.html) `
          <div class="card">
            <div class="card-header">
              <h3 class="card-title mb-0">${x => x.styleData.name}</h3>
              <div class="card-header-actions">
                ${(0, fast_element_1.when)(x => x.styleData.common, (0, fast_element_1.html) `
                  <span class="badge badge-info mr-2">${'style.common'.t()}</span>
                `)}
                <span class="badge ${x => x.styleData.active ? 'badge-success' : 'badge-secondary'}">
                  ${x => x.styleData.active ? 'style.active'.t() : 'style.inactive'.t()}
                </span>
              </div>
            </div>
            <div class="card-body">
              ${(0, fast_element_1.when)(x => x.styleData.description, (0, fast_element_1.html) `
                <div class="mb-4">
                  <h5>${'style.description'.t()}</h5>
                  <p class="text-muted">${x => x.styleData.description}</p>
                </div>
              `)}
              
              <div class="mb-4">
                <h5>${'style.prompt'.t()}</h5>
                <div class="style-prompt-preview">
                  <pre class="bg-light p-3 rounded">${x => x.styleData.prompt}</pre>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <h6>${'style.metadata'.t()}</h6>
                  <table class="table table-sm">
                    <tbody>
                      <tr>
                        <td><strong>${'style.common'.t()}</strong></td>
                        <td>${x => x.styleData.common ? 'general.yes'.t() : 'general.no'.t()}</td>
                      </tr>
                      <tr>
                        <td><strong>${'style.active'.t()}</strong></td>
                        <td>${x => x.styleData.active ? 'general.yes'.t() : 'general.no'.t()}</td>
                      </tr>
                      ${(0, fast_element_1.when)(x => x.styleData.created_at, (0, fast_element_1.html) `
                        <tr>
                          <td><strong>${'general.createdAt'.t()}</strong></td>
                          <td>${x => new Date(x.styleData.created_at).toLocaleDateString()}</td>
                        </tr>
                      `)}
                      ${(0, fast_element_1.when)(x => x.styleData.updated_at, (0, fast_element_1.html) `
                        <tr>
                          <td><strong>${'general.updatedAt'.t()}</strong></td>
                          <td>${x => new Date(x.styleData.updated_at).toLocaleDateString()}</td>
                        </tr>
                      `)}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        `)}
      </div>
    </div>
  </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.style-preview-page .top-right-button-container {
  position: absolute;
  top: 0;
  right: 0;
}
.style-preview-page .card-header {
  position: relative;
}
.style-preview-page .card-header .card-title {
  margin-bottom: 0;
}
.style-preview-page .card-header .card-header-actions {
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
}
.style-preview-page .style-prompt-preview pre {
  max-height: 400px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: "Courier New", monospace;
  font-size: 0.9rem;
  line-height: 1.4;
}
.style-preview-page .badge {
  font-size: 0.8rem;
}
.style-preview-page .table {
  margin-bottom: 0;
}
.style-preview-page .table td {
  padding: 0.5rem;
  border-top: 1px solid #dee2e6;
}`;
const shadowOptions = { "mode": "open" };
let StylePreview = class StylePreview extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.styleId = null;
        this.styleData = null;
    }
    get isUserSuperAdmin() {
        var _a;
        return ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN;
    }
    get isUserParentOrAdmin() {
        var _a, _b, _c;
        return ((_a = component_2.DefaultLayout.USER) === null || _a === void 0 ? void 0 : _a.role) === backendImport_1.UserRoles.SUPER_ADMIN || ((_b = component_2.DefaultLayout.USER) === null || _b === void 0 ? void 0 : _b.role) === backendImport_1.UserRoles.PARENT_USER || ((_c = component_2.DefaultLayout.USER) === null || _c === void 0 ? void 0 : _c.role) === backendImport_1.UserRoles.ENTERPRISE;
    }
    get canEdit() {
        if (!this.styleData)
            return false;
        // Super admin can edit everything
        if (this.isUserSuperAdmin)
            return true;
        // Parent users can edit their own styles but not common styles
        if (this.isUserParentOrAdmin) {
            return !(this.styleData.common === true && !this.isUserSuperAdmin);
        }
        // Regular users cannot edit any styles
        return false;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.styleId = this.routeParams.id;
        if (this.styleId) {
            await this.loadStyle();
        }
        else {
            this.notifyService.notify('style.invalidId'.t(), 'error');
            this.goBack();
        }
    }
    async loadStyle() {
        try {
            this.loading = true;
            const response = await this.apiService.back.get('style.get', {
                routeParams: { id: this.styleId }
            });
            if ((response === null || response === void 0 ? void 0 : response.success) && response.data) {
                this.styleData = response.data;
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'style.failedToLoad'.t(), 'error');
                this.goBack();
            }
        }
        catch (error) {
            console.error('Error loading style:', error);
            this.notifyService.notify('style.failedToLoad'.t(), 'error');
            this.goBack();
        }
        finally {
            this.loading = false;
        }
    }
    editStyle() {
        if (this.styleId) {
            component_1.SiteMenu.goto.bind(this)(`/settings/style/edit/${this.styleId}`);
        }
    }
    goBack() {
        component_1.SiteMenu.goto.bind(this)('/settings/style/list');
    }
};
exports.StylePreview = StylePreview;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], StylePreview.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], StylePreview.prototype, "styleId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof backendImport_1.IStyle !== "undefined" && backendImport_1.IStyle) === "function" ? _a : Object)
], StylePreview.prototype, "styleData", void 0);
exports.StylePreview = StylePreview = __decorate([
    (0, client_1.RWSView)('style-preview', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], StylePreview);
StylePreview.defineComponent();
